import { render } from "./AttributesIndex.vue?vue&type=template&id=4053658f&scoped=true"
import script from "./AttributesIndex.vue?vue&type=script&lang=js"
export * from "./AttributesIndex.vue?vue&type=script&lang=js"

import "./AttributesIndex.vue?vue&type=style&index=0&id=4053658f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4053658f"]])

export default __exports__